import { useFeatureValue } from "@growthbook/growthbook-react";
import { CENSUS_UPLOAD_CHECK } from "@platform/feature-flags";

import { admitsBroker } from "../uploadCheck/pilot";

import type { JSONValue } from "@growthbook/growthbook-react";

/**
 * Whether the census-upload-check flag admits the broker, by any of the ids
 * the broker may be listed under: the external id, or the Salesforce id a
 * broker signed in through Salesforce carries instead.
 */
export const useCensusUploadCheckEnabled = (
  brokerIds: readonly string[],
): boolean =>
  admitsBroker(
    useFeatureValue<JSONValue>(CENSUS_UPLOAD_CHECK, null),
    brokerIds,
  );
